(() => {
  const OPTION_GROUP_SELECTOR = '.product-form__input';
  const TRIGGER_OPTION_NAME = 'Family Member';

  /**
   * Returns the selected value from a radio-button
   * group or dropdown.
   */
  function getSelectedValue(group) {
    const checkedRadio = group.querySelector(
      'input[type="radio"]:checked'
    );

    if (checkedRadio) {
      return checkedRadio.value;
    }

    const select = group.querySelector('select');

    return select ? select.value : null;
  }

  /**
   * Selects a value inside a radio-button group
   * or dropdown.
   */
  function setSelectedValue(group, value) {
    const radios = Array.from(
      group.querySelectorAll('input[type="radio"]')
    );

    if (radios.length) {
      const matchingRadio = radios.find(
        (radio) => radio.value === value
      );

      if (!matchingRadio) {
        return;
      }

      matchingRadio.checked = true;

      // Update the displayed value when swatches are used.
      const selectedValueLabel = group.querySelector(
        '[data-selected-swatch-value]'
      );

      if (selectedValueLabel) {
        selectedValueLabel.textContent = value;
      }

      return;
    }

    const select = group.querySelector('select');

    if (select) {
      select.value = value;
    }
  }

  /**
   * Converts names such as "options[Family Member]"
   * to "Family Member".
   */
  function getOptionName(input) {
    return input.name
      .replace(/^options\[/, '')
      .replace(/\]$/, '')
      .trim();
  }

  function handleVariantChange(event) {
    const picker = event.target.closest('variant-selects');

    if (!picker) {
      return;
    }

    /*
     * Only run when the Family Member option changes.
     * Other option changes continue using normal Dawn behavior.
     */
    if (getOptionName(event.target) !== TRIGGER_OPTION_NAME) {
      return;
    }

    const optionGroups = Array.from(
      picker.querySelectorAll(OPTION_GROUP_SELECTOR)
    );

    const changedGroup = event.target.closest(
      OPTION_GROUP_SELECTOR
    );

    const changedOptionIndex =
      optionGroups.indexOf(changedGroup);

    if (
      changedOptionIndex === -1 ||
      changedOptionIndex >= optionGroups.length - 1
    ) {
      return;
    }

    const variantsScript = picker.querySelector(
      'script[type="application/json"]'
    );

    if (!variantsScript) {
      return;
    }

    let variants;

    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error(
        'Automatic variant selection: unable to read variants.',
        error
      );
      return;
    }

    if (!Array.isArray(variants)) {
      return;
    }

    const currentValues =
      optionGroups.map(getSelectedValue);

    /*
     * Find every variant matching the newly selected
     * Family Member and any options before it.
     */
    const matchingVariants = variants.filter((variant) => {
      return currentValues
        .slice(0, changedOptionIndex + 1)
        .every((selectedValue, index) => {
          return variant.options[index] === selectedValue;
        });
    });

    /*
     * Keep the existing Size when that exact
     * combination is available.
     */
    let targetVariant = matchingVariants.find((variant) => {
      if (!variant.available) {
        return false;
      }

      return variant.options.every((value, index) => {
        if (index <= changedOptionIndex) {
          return true;
        }

        return value === currentValues[index];
      });
    });

    /*
     * Otherwise select the first available combination
     * for the new Family Member.
     */
    if (!targetVariant) {
      targetVariant = matchingVariants.find(
        (variant) => variant.available
      );
    }

    /*
     * If all matching combinations are sold out,
     * select the first existing combination.
     */
    if (!targetVariant) {
      targetVariant = matchingVariants[0];
    }

    if (!targetVariant) {
      return;
    }

    /*
     * Update Size and any later product options before
     * Dawn reads the complete selected combination.
     */
    for (
      let index = changedOptionIndex + 1;
      index < optionGroups.length;
      index += 1
    ) {
      setSelectedValue(
        optionGroups[index],
        targetVariant.options[index]
      );
    }
  }

  /*
   * Capture mode makes this run before Dawn's
   * variant-selects change listener.
   */
  document.addEventListener(
    'change',
    handleVariantChange,
    true
  );
})();